import Vue from 'vue';
import VueRouter from 'vue-router';
import RootChrome from '@/layout/RootChrome.vue';
import AppChrome from '@/layout/AppChrome.vue';
import ErrorPage from '@/error/ErrorPage.vue';
import { createRoutes as createSummaryRoutes } from '@/summary';
import { createRoutes as createVideoRoutes } from '@/video';
import { createRoutes as createPerformanceRoutes } from '@/performance';
import { createRoutes as createIssuesRoutes } from '@/issues';
import { createRoutes as createPlaybackRoutes } from '@/playback';
import { guard, guardProject } from '@/router/guard';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: RootChrome,
      meta: { requiresAuth: true },
      children: [
        {
          path: ':teamName',
          name: 'TeamName',
          redirect: ':teamName/projects',
          component: AppChrome,
          children: [
            {
              path: '/',
              redirect: 'projects',
            },
            {
              path: 'projects',
              name: 'projectChrome',
              component: () => import(/* webpackChunkName: "projectList" */ '@/project/ProjectChrome.vue'),
              meta: { requiresProject: true },
              children: [
                {
                  path: 'create',
                  name: 'projectCreate',
                  component: () => import(/* webpackChunkName: "projectCreate" */ '@/project/ProjectCreate.vue'),
                },
                {
                  path: ':projectId',
                  name: 'project',
                  redirect: ':projectId/summary',
                  component: () => import(/* webpackChunkName: "project" */ '@/project/Project.vue'),
                  children: [
                    {
                      path: 'settings',
                      name: 'projectSettings',
                      redirect: 'settings/general',
                      component: () => import(/* webpackChunkName: "projectSettings" */ '@/project/ProjectSettings.vue'),
                      children: [
                        {
                          path: 'general',
                          name: 'projectSettingsGeneral',
                          component: () => import(/* webpackChunkName: "projectSettingsGeneral" */ '@/project/ProjectSettingsGeneral.vue'),
                        },
                        {
                          path: 'setup',
                          name: 'projectSettingsSetup',
                          component: () => import(/* webpackChunkName: "projectSettingsSetup" */ '@/project/ProjectSettingsSetup.vue'),
                        },
                        {
                          path: 'advanced',
                          name: 'projectSettingsAdvanced',
                          component: () => import(/* webpackChunkName: "projectSettingsAdvanced" */ '@/project/ProjectSettingsAdvanced.vue'),
                        },
                      ],
                    },
                    ...createSummaryRoutes(),
                    ...createVideoRoutes(),
                    ...createIssuesRoutes(),
                    ...createPerformanceRoutes(),
                    ...createPlaybackRoutes(),
                    {
                      path: '*',
                      name: 'ErrorPage_a',
                      component: ErrorPage,
                    },
                  ],
                },
              ],
            },
            {
              path: '*',
              name: 'ErrorPage_b',
              component: ErrorPage,
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach(guard);
router.beforeEach(guardProject);

export default router;
